import { useEffect } from "react";
import { SCHEDULE_END_TYPES, type ScheduleEndType } from "../SchedulerUtils";

interface ScheduleEndNeverChange {
  type: ScheduleEndType;
  data: ScheduleEndType;
}

interface ScheduleEndNeverProps {
  onChange: (change: ScheduleEndNeverChange) => void;
}

const ScheduleEndNever = ({ onChange }: ScheduleEndNeverProps) => {
  useEffect(() => {
    onChange({
      type: SCHEDULE_END_TYPES.NEVER,
      data: SCHEDULE_END_TYPES.NEVER,
    });
  }, [onChange]);

  return null;
};

export default ScheduleEndNever;
